import { render, staticRenderFns } from "./Wage.vue?vue&type=template&id=4e8a0ba3&scoped=true"
import script from "./Wage.vue?vue&type=script&lang=js"
export * from "./Wage.vue?vue&type=script&lang=js"
import style0 from "./Wage.vue?vue&type=style&index=0&id=4e8a0ba3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a0ba3",
  null
  
)

export default component.exports